import { render, staticRenderFns } from "./LayoutHorizontalSidenav.vue?vue&type=template&id=7091fe22&"
import script from "./LayoutHorizontalSidenav.vue?vue&type=script&lang=js&"
export * from "./LayoutHorizontalSidenav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports